import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  & > div {\n    div {\n      border: none;\n      outline: none;\n      &:hover,\n      &:focus {\n        border: none;\n        outline: none;\n      }\n      input {\n        border: 1px solid ", ";\n        border-radius: 4px;\n      }\n      label {\n        color: ", ";\n      }\n    }\n    margin-bottom: 1rem;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  color: ", " !important;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        width: 85%;\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        width: 50%;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        width: 45%;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  width: 100%;\n  margin 10rem 0;\n\n  h3 {\n    font-family: ", ";\n    font-size: 28px;\n    margin-bottom: 1rem;\n  }\n\n  p {\n    color: ", ";\n    font-size: 14px;\n    font-family: 'Inter';\n    margin-bottom: 2rem;\n  }\n  form{ \n    width: 25%;\n      & > button {\n      margin-top: 2rem;\n      width: 100%;\n      letter-spacing: 3px;\n      background-color: ", ";\n      border-radius: 4px;\n      &:hover{\n        background-color: ", ";\n      }\n      & > span {\n        font-size: 13px;\n      }\n    }\n    & > span {\n      margin-top: 2rem;\n      text-align: center;\n      width: 100%;\n      display: block;\n      font-family: Inter;\n      font-size: 12px;\n    }\n    ", ";\n    ", ";\n    ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
export var Wrapper = styled.div(_templateObject(), function (props) {
  return props.theme.typography.baseFontFamily;
}, function (props) {
  return props.theme.colors.lightFont;
}, function (props) {
  return props.theme.colors.red;
}, function (props) {
  return props.theme.colors.hoverRed;
}, media.xLargeScreen(_templateObject2()), media.mediumScreen(_templateObject3()), media.smallScreen(_templateObject4()));
export var GeneralError = styled.p(_templateObject5(), function (props) {
  return props.theme.colors.error;
});
export var InputFields = styled.div(_templateObject6(), function (props) {
  return props.theme.colors.dividerDark;
}, function (props) {
  return props.theme.colors.dividerDark;
});